var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 6,
    viewBox: "0 0 12 6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "down",
    d: "M634.083,756.68a.518.518,0,0,1-.153.37l-4.513,4.553a1.883,1.883,0,0,1-2.671,0l-4.513-4.553a.528.528,0,0,1,0-.74.519.519,0,0,1,.733,0l4.513,4.553a.847.847,0,0,0,1.2,0l4.513-4.553a.519.519,0,0,1,.733,0A.549.549,0,0,1,634.083,756.68Z",
    transform: "translate(-622.083 -756.158)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/down.18a1cf2b27219bcd356965c363afb4d6.svg";
export { ForwardRef as ReactComponent };